import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadCostshareInfo, SaveFinalizedClaim } from '../../Services/loadOrder';
import MenuBar from './MenuBar';
import { DataGrid } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import "../../assets/css/home.css";
import toast ,{ Toaster} from 'react-hot-toast'; 
import { useLocation } from 'react-router-dom';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { exportToExcel } from '../../utils/exportToExcel';
import { FaFileExcel } from 'react-icons/fa';
import RefundCostShareModal from './RefundCostShareModal';
import Select from 'react-select';

const CostShareInfo = () => {
  const { state } = useLocation();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogRow, setDialogRow] = useState(null);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [dropdownData, setDropdownData] = useState([]);
  const [dropdownDataClaimId, setDropdownDataClaimId] = useState([]);
  const [selectedClaimId, setSelectedClaimId] = useState(null);
  const [refundData, setRefundData] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0); // State to trigger re-render
  const navigate = useNavigate(); // 


  const user = JSON.parse(localStorage.getItem('user'));
  const userId = user?.userId;
  const pharmName = user?.pharmName;

  const {
    MemberID,
    contract,
    pharmacyId
  } = state || {};

  const filteredRows = selectedClaimId
  ? rows.filter(row => row.ClaimID === selectedClaimId)
  : rows;

  const columns = [
    { field: 'Contract', headerName: 'Contract', flex:1, headerClassName: 'pink-header', backgroundColor: '#ec008c',
      renderHeader: () => (
        <span style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', textAlign: 'center', display: 'block' }}>
          Contract
        </span>
      )
    },
    { field: 'MemberID', headerName: 'Member ID', flex:1.2, headerClassName: 'pink-header', 
      renderHeader: () => (
        <span style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', textAlign: 'center', display: 'block' }}>
          Member ID
        </span>
      )
    },
    { field: 'FirstName', headerName: 'First Name', flex:1, headerClassName: 'pink-header',
      renderHeader: () => (
        <span style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', textAlign: 'center', display: 'block' }}>
          First<br />Name
        </span>
      )
    }, 
    { field: 'LastName', headerName: 'Last Name',flex:.8, headerClassName: 'pink-header', backgroundColor: '#ec008c',
      renderHeader: () => (
        <span style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', textAlign: 'center', display: 'block' }}>
          Last<br />Name
        </span>
      )
    },
    { field: 'MemberDOB', headerName: 'MemberDOB',flex:1, headerClassName: 'pink-header',
      renderHeader: () => (
        <span style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', textAlign: 'center', display: 'block' }}>
          Member<br />DOB
        </span>
      )
    },
    { field: 'AuthorizationNumber', headerName: 'AuthorizationNumber', flex:1.5, headerClassName: 'pink-header',
      renderHeader: () => (
        <span style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', textAlign: 'center', display: 'block' }}>
          Authorization<br />Number
        </span>
      )
    },
    { field: 'ClaimID', headerName: 'Claim ID', flex:1.1, headerClassName: 'pink-header',
      renderHeader: () => (
        <span style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', textAlign: 'center', display: 'block' }}>
          Claim ID
        </span>
      )
    },
    { field: 'OrderAmount', headerName: 'Order Amount', flex:1, headerClassName: 'pink-header',
      renderHeader: () => (
        <span style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', textAlign: 'center', display: 'block' }}>
          Order<br />Amount
        </span>
      )
    },
    { field: 'CostShareAtOrderDispense', headerName: 'Cost Share at Order Dispense',flex:1.4, headerClassName: 'pink-header',
      renderHeader: () => (
        <span style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', textAlign: 'center', display: 'block' }}>
          Cost Share at<br /> Order Dispense
        </span>
      )
    },
    { field: 'TotalCostShareAfterClaimsAdjudication', headerName: 'Total Cost Share After Claims Adjudication', flex:1.5, headerClassName: 'pink-header',
      renderHeader: () => (
        <span style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', textAlign: 'center', display: 'block' }}>
          Total Cost Share<br />After Claims<br />Adjudication
        </span>
      )
    },
    { field: 'CheckOrEFTNumber', headerName: 'Check OR EFT Number',flex:1, headerClassName: 'pink-header',
      renderHeader: () => (
        <span style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', textAlign: 'center', display: 'block' }}>
          Check OR<br />EFT Number
        </span>
      )
    },
    { field: 'DispensedDate', headerName: 'Dispensed Date',flex:1, headerClassName: 'pink-header',
      renderHeader: () => (
        <span style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', textAlign: 'center', display: 'block' }}>
          Dispensed<br />Date
        </span>
      )
    },
    { field: 'DateOfPaymentToVendor', headerName: 'Date Of Payment To Vendor', flex:1.5, headerClassName: 'pink-header',
      renderHeader: () => (
        <span style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', textAlign: 'center', display: 'block' }}>
          Date Of<br />Payment To<br />Vendor
        </span>
      )
    },
    { field: 'PharmacyPaidAmount', headerName: 'Pharmacy Paid Amount', flex:1.1, headerClassName: 'pink-header',
      renderHeader: () => (
        <span style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', textAlign: 'center', display: 'block' }}>
          Pharmacy<br />Paid Amount
        </span>
      )
    },
    { field: 'EOBDate', headerName: 'EOB Date', flex:1.4, headerClassName: 'pink-header',
      renderHeader: () => (
        <span style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', textAlign: 'center', display: 'block' }}>
          EOB Date
        </span>
      )
    },
    {
      field: 'FinalizedWithMember',
      headerName: 'Finalized with Member',
      flex:1,
      headerClassName: 'pink-header',
      renderCell: (params) => {
        const checked = params.row.CheckBox === 'Y';
        return (
          <Checkbox
            checked={checked}
            disabled={checked}
            onChange={() => {
              if (!checked) {
                setDialogRow(params.row);
                setDialogOpen(true);
              }
            }}
          />
        );
      },
      renderHeader: () => (
        <span style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', textAlign: 'center', display: 'block' }}>
          Finalized<br />with Member
        </span>
      )
    }
  ];

 useEffect(() => {
  const fetchData = async () => {
    try {
    
      const orderResponse = await LoadCostshareInfo(pharmacyId, MemberID, contract);
      const data = orderResponse?.Details;

      const dropdownDataClaimId = data?.map(item => item.ClaimID) || [];
      setDropdownDataClaimId(dropdownDataClaimId);

      const dropdownData = data?.map(item => ({
        label: `${item.ClaimID} - ${item.OrderAmount}`,
        value: item.ClaimID,
        orderAmount: item.OrderAmount,

      }));

      

      setDropdownData(dropdownData);

      setRefundData(orderResponse?.RefundDetails || []); // Store refund details for later use
      if (Array.isArray(data)) {
        const formattedRows = data.map((item, id) => ({
          id: id + 1,
          Contract: item.Contract || '',
          MemberID: item.MemberID || '',
          FirstName: item["First Name"] || '',
          LastName: item["Last Name"] || '',
          MemberDOB: item.MemberDOB ? item.MemberDOB.split('T')[0] : '',
          AuthorizationNumber: item.Authnumber || '',
          ClaimID: item.ClaimID || '',
          OrderAmount: item.OrderAmount || '',
          CostShareAtOrderDispense: item["Cost Share at Order Dispense"] || '',
          TotalCostShareAfterClaimsAdjudication: item.TotalCostShareAfterClaimsAdjudication || '',
          CheckOrEFTNumber: item["Check OR EFT Number"] || '',
          DispensedDate: item.DispensedDate ? item.DispensedDate.split('T')[0] : '',
          DateOfPaymentToVendor: item.DateOfPaymentToVendor ? item.DateOfPaymentToVendor.split('T')[0] : '',
          PharmacyPaidAmount: item["Pharmacy Paid Amount"] || '',
          EOBDate: item["EOB Date"] ? item["EOB Date"].split('T')[0] : '',
          CheckBox: item.CheckBox || 'N',
        }));
        setRows(formattedRows);
        if (data.length === 0) {
          toast.error('No rows found.');
        }
      } else {
        setRows([]);
        toast.error('No rows found.');
        console.log("Unexpected data structure:", orderResponse);
      }
    } catch (error) {
      console.error("Failed to load cost share details:", error);
      navigate('/error-page');
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [refreshKey]);

  // Render all labels/UI first, then overlay spinner if loading
  return (
    <div>
      <Toaster position="top-right"  />
      <MenuBar />
      <div className='top-page-option'>
        <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center' }}>
          <a href="#/cost-share-details" style={{ textDecoration: 'none', color: '#ec088c', display: 'inline-flex', alignItems: 'center' }}>
            <ChevronLeft color='#ec088c' size={18} />
            <span style={{ marginLeft: '5px' }}>Back</span>
          </a>
        </div>
        <div>
        
        <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          Dispensed Orders
          <ChevronRight color='#ec088c' size={18} />
          Cost Share Details
          <ChevronRight color='#ec088c' size={18} />
          Cost Share Info
        
        
<span style={{ display: 'flex',justifyContent:'right', alignItems: 'center', gap: '8px' ,marginLeft:'auto', marginRight:'6.2%' }}>       <Select
      options={dropdownDataClaimId.map(id => ({ label: id, value: id }))}
      placeholder="Filter by Claim ID"
      isClearable
      value={selectedClaimId ? { label: selectedClaimId, value: selectedClaimId } : null}
      onChange={option => setSelectedClaimId(option ? option.value : null)}
      styles={{
        container: (base) => ({
          ...base,
          minWidth: 220,
          maxWidth: 260,
          marginLeft: 12,
        }),
        control: (base) => ({
          ...base,
          minHeight: 32,
          fontSize: 12,
          borderRadius: 6,
          borderColor: '#ec008c',
          boxShadow: 'none',
        }),
        valueContainer: (base) => ({
          ...base,
          padding: '2px 8px',
        }),
        input: (base) => ({
          ...base,
          margin: 0,
          padding: 0,
        }),
        indicatorsContainer: (base) => ({
          ...base,
          height: 32,
        }),
        dropdownIndicator: (base) => ({
          ...base,
          padding: 4,
        }),
        clearIndicator: (base) => ({
          ...base,
          padding: 4,
        }),
        option: (base) => ({
          ...base,
          fontSize: 12,
          color: 'black',
        })
      }}
    />
  </span>
  </div>
  </div>
      </div>
      <div style={{ height: '60vh', width: '87%', margin: 'auto' }}>
        <DataGrid
          rows={filteredRows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[10, 25, 50]}
          disableSelectionOnClick
          hideFooter
          sx={{
            fontSize: '12px',
            fontFamily: 'Segoe UI',
            '& .pink-header': { backgroundColor: '#ec008c', color:'#fff', fontWeight: 'bold' },
            '& .MuiDataGrid-cell': {
              py: 0.1,
              px: 0.5,
              whiteSpace: 'pre-line',
              wordBreak: 'break-word',
              textAlign: 'center',
              display: 'block',
              lineHeight: 1.2
            },
            '& .MuiDataGrid-columnHeaders': { backgroundColor: '#e0f7fa' },
            '& .MuiDataGrid-row:hover': { backgroundColor: '#f5f5f5', color: 'black' },
            '& .MuiDataGrid-row.Mui-selected, & .MuiDataGrid-row.Mui-selected:hover': {
              backgroundColor: 'inherit',
              color: 'inherit'
            },
            '& .MuiDataGrid-row:active': {
              backgroundColor: 'inherit',
              color: 'inherit'
            }
          }}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '85%', margin: '10px auto 0 auto' }}>
        <button style={{ padding: '6px 12px', backgroundColor: '#ec008c', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', marginRight: '8px' }}
        onClick={() => setShowRefundModal(true)}>Refund</button>  

        <Button
          variant="outlined"
          onClick={() => {
            // Always add/export the Finalized with Member column as Y/N
            const exportColumns = columns.map(col =>
              col.field === 'FinalizedWithMember'
                ? { ...col, headerName: 'Finalized with Member' }
                : col
            );
            // If the column doesn't exist, add it
            const hasFinalized = exportColumns.some(col => col.field === 'FinalizedWithMember');
            const finalColumns = hasFinalized ? exportColumns : [
              ...exportColumns,
              { field: 'FinalizedWithMember', headerName: 'Finalized with Member' }
            ];
            const exportRows = rows.map(row => ({
              ...row,
              FinalizedWithMember: row.CheckBox === 'Y' ? 'Yes' : 'No'
            }));
            exportToExcel(finalColumns, exportRows, 'CostShareInfo');
          }}
          sx={{ mb: 1, minWidth: 0, p: 0.5 }}
        >
    <FaFileExcel style={{ width: 30, height: 35 , color: '#008000'}} title="Download XLSX" alt="Excel" />
        </Button>
      </div>
      
      {/* Dialog for confirmation */}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ textAlign: 'center', color: '#ec008c', fontWeight: 'bold' }}>Finalize Claim</DialogTitle>
        <DialogContent sx={{ textAlign: 'center', fontSize: '16px' }}>
          Cost share reconciled for this claim?
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button onClick={async () => {
            if (dialogRow) {
              try {
                // Call SaveFinalizedClaim API with all required parameters
                const result = await SaveFinalizedClaim(
                  dialogRow.ClaimID, // ClaimID
                  contract, // contract
                  dialogRow.MemberID, // memberid
                  dialogRow.AuthorizationNumber, // AUTHNUMBER
                  dialogRow.CostShareAtOrderDispense, // COSTSHAREATORDERDISPENSE
                  dialogRow.TotalCostShareAfterClaimsAdjudication, // TOTALCOSTSHAREAFTERCLAIMSADJUDICATION
                  dialogRow.OrderAmount, // ORDERAMOUNT
                  userId // user
                );
               
                  setRows((prevRows) => prevRows.map(row =>
                    row.id === dialogRow.id ? { ...row, CheckBox: 'Y' } : row
                  ));
                  toast.success('Claim finalized successfully!');
                } catch (e) {
                  toast.error('Error finalizing claim.');
                }
              }
              setDialogOpen(false);
            }}
            variant="contained"
            sx={{
              backgroundColor: "#ec008c",
              color: "#fff",
              '&:hover': { backgroundColor: "#d0007a" }
            }}
          >
            Yes
          </Button>
          <Button
            onClick={() => setDialogOpen(false)}
            variant="outlined"
            sx={{
              color: "#ec008c",
              borderColor: "#ec008c",
              '&:hover': { borderColor: "#d0007a", color: "#d0007a" }
            }}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
      {loading && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(255,255,255,0.7)', zIndex: 2000, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #EC088C', borderRadius: '50%', width: 48, height: 48, animation: 'spin 1s linear infinite' }} />
          <div style={{marginTop: 24, fontSize: '1.2rem', fontWeight: 500, color: '#222'}}>Your request is being processed</div>
          <style>{`@keyframes spin { 0% { transform: rotate(0deg);} 100% {transform: rotate(360deg);} }`}</style>
        </div>
      )}
      {showRefundModal && (
        <RefundCostShareModal
          open={showRefundModal}
          onClose={() => setShowRefundModal(false)}
          pharmacyId={pharmacyId}
          memberID={MemberID}
          contract={contract}
          pharmName={pharmName}
          refundData={refundData}
          dropdownData={dropdownData}
          onConfirm={() => {
            setRefreshKey(prevKey => prevKey + 1); // Trigger re-render
            toast.success('Refund process initiated successfully!');
            setShowRefundModal(false);
          }}
        />
      )}
    </div>
  );
}; 

export default CostShareInfo;